export default __webpack_public_path__ + "static/media/privacy.7adcb24d.pdf";